/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Link from 'next/link';
import { TeamDetailItemFragment } from '@amf/shared/types/graphql';
import Container from '@amf/shared/components/layout/Container';
import { useTranslate } from '@tolgee/react';

interface TeamHeaderProps {
  team: TeamDetailItemFragment;
  prefixes: { club: string };
}

function TeamHeader({ team, prefixes }: TeamHeaderProps) {
  const { t } = useTranslate();
  return (
    <div className='mt-40 sm:mt-56'>
      <Container>
        <div className='flex flex-col sm:flex-row items-center gap-8'>
          <div className='w-24 h-24 rounded-full overflow-hidden border border-zinc-200'>
            {team.club.brandUrl && (
              <img className='w-full h-full' src={team.club.brandUrl} alt={team.club.name} />
            )}
            {!team.club.brandUrl && (
              <div className='w-full h-full'>{team.name.substring(0, 1)}</div>
            )}
          </div>
          <div>
            <h1 className='before:hidden m-0 font-black text-3xl sm:text-6xl font-primary text-black block text-center sm:text-left'>
              {team.name}
            </h1>
            <p className='text-lg text-zinc-600 text-center sm:text-left'>
              {t(`league.type.${team.type}`)} / {team.club.name}
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default TeamHeader;
